import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Testimonials = ({ data, section }) => {
  const s = section || {};
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <SectionHeader heading={s.heading} />
        </div>
        <div className="row">
          {data
            ? data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      <img src={d.img} alt={d.name} />
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta">— {d.name}</div>
                    </div>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
